import type { RouteRecordRaw } from 'vue-router';

import { EnumRoutes } from '@/helpers/enums/routes.enum';

export const internalTeamRoutes: Array<RouteRecordRaw> = [
  {
    path: EnumRoutes.internalTeamRoutesEnum.root.path,
    name: EnumRoutes.internalTeamRoutesEnum.root.name,
    component: () => import('@/views/internal-team/InternalTeamPage.vue'),
    meta: EnumRoutes.internalTeamRoutesEnum.root.meta,
  },
  {
    path: EnumRoutes.internalTeamRoutesEnum.onboarding.path,
    name: EnumRoutes.internalTeamRoutesEnum.onboarding.name,
    component: () =>
      import('@/views/internal-team/onboarding/OnboardingWizard.vue'),
    meta: EnumRoutes.internalTeamRoutesEnum.onboarding.meta,
  },
];
